import { Component } from '@angular/core';
import { AbstractControl, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { Storage } from 'aws-amplify';
import { ClinicSetupService } from '../logged-in-navbar/clinic-setup-modal/clinic-setup.service';

export function arrayNotEmptyValidator(): ValidatorFn {
  return (control: AbstractControl) => {
    const isValid = control.value && control.value.length > 0;
    return isValid ? null : { required: true };
  };
}

@Component({
  selector: 'app-drug-request',
  templateUrl: './drug-request.component.html',
  styleUrls: ['./drug-request.component.css']
})
export class DrugRequestComponent {
  drugFormGroup: FormGroup;
  public showPhotoField: boolean;

  constructor(private clinicSetupService: ClinicSetupService, private _snackBar: MatSnackBar) {
    this.drugFormGroup = new FormGroup({
      name: new FormControl('', Validators.required),
      activeIngredients: new FormControl([]),
      linkOrPhotoToggle: new FormControl(''),
      link: new FormControl(''),
      photos: new FormControl([]),
      dosageForm: new FormControl(''),
      country: new FormControl('')
    });
  }

  ngOnInit() {
    this.drugFormGroup.controls.linkOrPhotoToggle.valueChanges.subscribe(value => {
      if (value === 'photo') {
        this.showPhotoField = true;
        this.drugFormGroup.controls.photos.enable();
        this.drugFormGroup.controls.photos.setValidators([
          Validators.required,
          arrayNotEmptyValidator()
        ]);
        this.drugFormGroup.controls.link.disable();
      } else {
        this.showPhotoField = false;
        this.drugFormGroup.controls.link.enable();
        this.drugFormGroup.controls.photos.disable();
        this.drugFormGroup.controls.link.setValidators(Validators.required);
      }
    });
  }

  onSubmit() {
    if (this.drugFormGroup.invalid) {
      this.markFormGroupTouched(this.drugFormGroup);
      return;
    }

    const formValues = this.drugFormGroup.value;
    const activeIngredientsArray = formValues.activeIngredients.map((ingredient: string) => {
      const [ingredientName, strength] = ingredient.includes(':')
        ? ingredient.split(':')
        : [ingredient, ''];
      return { ingredient: ingredientName.trim(), strength: parseFloat(strength.trim()) || null };
    });

    const drugData = {
      name: formValues.name,
      active_ingredients: activeIngredientsArray,
      dosage_form: formValues.dosageForm || '',
      country: formValues.country || ''
    };

    this.uploadToS3(drugData);
  }

  uploadToS3(drugData: any) {
    let dateNow = new Date();
    const date = dateNow.getFullYear() + '-' + (dateNow.getMonth() + 1) + '-' + dateNow.getDate();
    const fileName = `${this.clinicSetupService.clinic.name +
      ' ' +
      date +
      ' ' +
      drugData.name.toLowerCase().replace(/\s+/g, '-')}.json`;
    const jsonBlob = new Blob([JSON.stringify(drugData, null, 2)], {
      type: 'application/json'
    });

    Storage.put(fileName, jsonBlob, {
      bucket: 'drug-request',
      level: 'public'
    })
      .then(() => {
        this._snackBar.open(
          `Drug request for ${this.drugFormGroup.controls.name.value} submitted successfully.`,
          '',
          { duration: 3000 }
        );
        this.drugFormGroup.reset();
      })
      .catch(err => {
        console.error('Error uploading file:', err);
      });
  }

  markFormGroupTouched(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(key => {
      const control = formGroup.get(key);
      if (control) {
        control.markAsTouched();
      }
    });
  }
}
